import s from "./Footer.module.scss";
import InstagramLogo from "../components/InstagramLogo";
import TiktokLogo from "../components/TiktokLogo";
import { INSTAGRAM_URL, TIKTOK_URL } from "../config/socialLinks";
import { trackCtaClick, trackEvent } from "../utils/analytics";
import { getLocalizedPath, useLanguage } from "../contexts/LanguageContext";

const footerTaglines = {
  JP: "宮古島の絶景でお待ちしてます",
  EN: "We look forward to welcoming you to Miyakojima's spectacular scenery.",
  中文: "在宫古岛的绝景中等候你的到来。",
  한국어: "미야코지마의 절경에서 기다리고 있습니다.",
};

const Footer = () => {
  const { lang } = useLanguage();
  const localizedPath = (path) => getLocalizedPath(path, lang);
  const homePath = localizedPath("/");
  const toursPath = localizedPath("/tours");
  const galleryPath = localizedPath("/gallery");
  const itineraryPath = localizedPath("/itinerary");
  const oceanGuidePath = localizedPath("/ocean-guide");
  const droneMapPath = localizedPath("/drone-map");
  const aboutPath = `${homePath}#about-me`;
  const faqPath = localizedPath("/faq");
  const blogPath = localizedPath("/blog");
  const contactPath = localizedPath("/contact");

  return (
    <footer className={s.root}>
      <div className={s.top}>
        <div className={s.brand}>
          <h2>Premium Tour Miyakoisland</h2>
          <p>{footerTaglines[lang] || footerTaglines.JP}</p>

          <div className={s.socials}>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                trackCtaClick({
                  label: "instagram_footer",
                  placement: "footer",
                  destination: INSTAGRAM_URL,
                  destinationType: "external_social",
                })
              }
            >
              <InstagramLogo />
            </a>
            <a
              href={TIKTOK_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                trackCtaClick({
                  label: "tiktok_footer",
                  placement: "footer",
                  destination: TIKTOK_URL,
                  destinationType: "external_social",
                })
              }
            >
              <TiktokLogo />
            </a>
          </div>
        </div>

        <div className={s.links}>
          <h3>Menu</h3>
          <a
            href={homePath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "home",
                destination: homePath,
                placement: "footer",
              })
            }
          >
            Home
          </a>
          <a
            href={toursPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "tours",
                destination: toursPath,
                placement: "footer",
              })
            }
          >
            Tours
          </a>
          <a
            href={galleryPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "gallery",
                destination: galleryPath,
                placement: "footer",
              })
            }
          >
            Gallery
          </a>
          <a
            href={itineraryPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "itinerary",
                destination: itineraryPath,
                placement: "footer",
              })
            }
          >
            Itinerary
          </a>
          <a
            href={oceanGuidePath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "ocean_guide",
                destination: oceanGuidePath,
                placement: "footer",
              })
            }
          >
            Ocean Guide
          </a>
          <a href="/ocean-guide/spots">{lang === "JP" ? "ビーチ・観光スポット" : "Beach & Spot Guide (JP)"}</a>
          <a href="/ocean-guide/restaurants">{lang === "JP" ? "飲食店・カフェ" : "Food & Cafe Guide (JP)"}</a>
          <a href="/ocean-guide/hotels">{lang === "JP" ? "ホテル・ヴィラを探す" : "Hotel & Villa Guide (JP)"}</a>
          {lang === "JP" && (
            <>
              <a href="/ocean-guide/snorkeling">シュノーケルガイド</a>
              <a href="/ocean-guide/beach">ビーチ遊びガイド</a>
              <a href="/ocean-guide/stargazing">星空ガイド</a>
              <a href="/ocean-guide/sunset">サンセットガイド</a>
            </>
          )}
          <a
            href={droneMapPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "drone_map",
                destination: droneMapPath,
                placement: "footer",
              })
            }
          >
            Drone Map
          </a>
          <a
            href={aboutPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "about",
                destination: aboutPath,
                placement: "footer",
              })
            }
          >
            About me
          </a>
          <a
            href={faqPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "faq",
                destination: faqPath,
                placement: "footer",
              })
            }
          >
            FAQ
          </a>
          <a
            href={blogPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "blog",
                destination: blogPath,
                placement: "footer",
              })
            }
          >
            Blog
          </a>
          <a
            href={contactPath}
            onClick={() =>
              trackEvent("nav_click", {
                event_category: "navigation",
                event_label: "contact",
                destination: contactPath,
                placement: "footer",
              })
            }
          >
            Contact
          </a>
          {lang === "JP" && (
            <a
              href="/web-production"
              onClick={() =>
                trackEvent("nav_click", {
                  event_category: "navigation",
                  event_label: "web_production",
                  destination: "/web-production",
                  placement: "footer",
                })
              }
            >
              Web制作依頼はこちら
            </a>
          )}
        </div>

        <div className={s.contact}>
          <h3>Contact</h3>
          <p>Email</p>
          <span>rererererereren77@gmail.com</span>
          <p>Phone</p>
          <span>+81 8019346245</span>
        </div>
      </div>
      <div className={s.bottom}>
        © 2026 Premium Tour Miyakoisland. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
